<!--  -->
<template>
  <div class="lisnewk">
    <div style="margin-bottom:10px">
      <el-input v-model="objr.link_template_no" style="width:200px;margin-right:5px" placeholder="请输入模板编号" />
      <el-input v-model="objr.book_name" style="width:200px;margin-right:5px" placeholder="请输入书名" />
      <el-select v-model="objr.promotion_type" placeholder="请选择推广类型">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button style="margin-left:10px" type="primary" @click="serach">搜索</el-button>
      <el-button type="primary" @click="reset">重置</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="promotion_type_text"
        label="推广类型"
        width="100"
        align="center"
      />
      <el-table-column
        prop="book_name"
        label="书名"
        width="180"
        align="center"
      />
      <el-table-column
        prop="chapter_name"
        label="章节名"
        width="180"
        align="center"
      />
      <el-table-column
        prop="book_platform_name"
        label="平台名"
        width="130"
        align="center"
      />
      <el-table-column
        prop="link_template_no"
        label="模板编号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="book_platform_name"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="delrte(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { promotionlinktemplate } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      objr: {
        page: 1,
        page_size: 10,
        platform_id: null,
        link_template_no: null,
        book_name: null,
        promotion_type: null,
        mini_program: null
      },
      total: null,
      tableData: [],
      options: [{
        value: 1,
        label: '内推'
      }, {
        value: 2,
        label: '外推'
      }]
    }
  },
  created() {
    // this.serlist()
  },
  mounted() {

  },
  methods: {
    async serlist() {
      const data = await promotionlinktemplate(this.objr)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    send(val,switchvalue) {
      this.objr.platform_id = val
      this.objr.mini_program = switchvalue
      this.serlist()
      console.log('平台id', val)
    },
    add() {
      this.dialogVisible = true
    },
    updata() {
    // 更新列表
      this.dialogVisible = false
      this.serlist()
    },
    fetchPageSizeone(e) {
      this.objr.page_size = e
      this.serlist()
    },
    fetchCurrentPageone(e) {
      this.objr.page = e
      this.serlist()
    },
    delrte(item) {
      this.$emit('sclinkcallback', item)
    },
    serach() {
      this.objr.page = 1
      this.serlist()
    },
    reset() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.link_template_no = null
      this.objr.book_name = null
      this.objr.promotion_type = null
      this.serlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.lisnewk{
  padding: 20px;
}
.addlinkbox{
  text-align: right;
  margin-bottom: 10px;
}
</style>
